import React, { ReactNode } from "react";
import { Provider } from "react-redux";
import store, { ToasterContext } from "./store";

interface IProps {
    children: ReactNode;
    renderToasts?: ReactNode;
}

export default function ToasterProvider({ children, renderToasts }: IProps) {
    return (
        <Provider store={store} context={ToasterContext}>
            {children}
            {renderToasts}
        </Provider>
    );
}
